// DeleteAuthModal.tsx
import axios from "axios";
import React, { useState } from "react";
import { env, useGlobalState } from "../../helpers/GlobalStateProvider";
import { useModalState } from "../../helpers/ModalProvider";
import { getApiUrl } from "../../config";
import { getToken } from "../../helpers/tokenManager";
import { DialogBody, DialogCloseTrigger, DialogContent, DialogFooter, DialogHeader, DialogRoot, DialogTitle } from "../../components/ui/dialog";
import { Text } from "@chakra-ui/react";
import { Button } from "../../components/ui/button";

const DeleteAuthModal: React.FC = () => {
  const {
    isDeleteAuthModalVisible,
    deleteAuthType,
    deleteAuthIdentifier,
    closeDeleteAuthModal,
    showErrorMessage,
  } = useModalState();

  const { refreshAccountInfo } = useGlobalState();

  const [isLoading, setIsLoading] = useState(false);

  const onConfirm = async () => {
    try {
      const bearerToken = getToken();
      if (!bearerToken) {
        return;
      }

      setIsLoading(true);
      // Call API to remove the chosen auth method
      const response = await axios.post(
        `${getApiUrl(env)}/v3/apiKey/delete_auth_method`,
        { method: deleteAuthType }, // 'email' or 'wallet'
        { headers: { Authorization: `Bearer ${bearerToken}` } },
      );
      if (process.env.NODE_ENV === 'development') console.log(
        `${deleteAuthType} auth removed successfully:`,
        response.data,
      );

      // Refresh user info to reflect changes
      await refreshAccountInfo();

      // Close the modal
      closeDeleteAuthModal();
    } catch (error: any) {
      showErrorMessage(
        `An unexpected error occurred. ${error?.response?.data?.message}`,
      );
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <DialogRoot lazyMount open={isDeleteAuthModalVisible} onOpenChange={(e) => { if (!e.open) closeDeleteAuthModal(); }}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Delete authentication method?</DialogTitle>
          <DialogCloseTrigger />
        </DialogHeader>
        <DialogBody>
          <Text fontSize="md" color="#52525b" lineHeight="24px">
            Are you sure you want to delete <strong>{deleteAuthType}</strong>{" "}
            authentication method
            {deleteAuthIdentifier ? `: ${deleteAuthIdentifier}?` : "?"}
            <br />
            This will permanently remove this authentication method from your
            account.
          </Text>
        </DialogBody>
        <DialogFooter>
          <Button variant="outline" onClick={closeDeleteAuthModal}>
            Cancel
          </Button>
          <Button colorPalette="red" onClick={onConfirm} loading={isLoading}>
            Delete
          </Button>
        </DialogFooter>
      </DialogContent>
    </DialogRoot>
  );
};

export default DeleteAuthModal;
